import { FontIconName } from "client/Components";
import {
	AnnouncementStatisticsModel,
	registerFollowComments,
	unregisterFollowComments
} from "client/Api/Hub/Announcements/announcementViewer";
import { AlertManager, useAlerts, useIsMounted } from "client/Hooks";
import { useCallback, useMemo } from "react";
import { localize } from "client_legacy/ndaw/culture";

export function useFollowAction(
	announcementId: number,
	isFollowing: boolean,
	onStatisticsChanged: (statistics: AnnouncementStatisticsModel) => void
): [icon: FontIconName, key: LocalizationKey, clickHandler: () => void] {
	const alertManager: AlertManager = useAlerts();
	const isMounted: () => boolean = useIsMounted();

	const clickHandler = useCallback(
		async (): Promise<void> => {
			try {
				const statistics: AnnouncementStatisticsModel = isFollowing
					? await unregisterFollowComments(announcementId)
					: await registerFollowComments(announcementId);

				if (!isMounted()) {
					return;
				}

				onStatisticsChanged(statistics);
			} catch (e) {
				console.error(e);
				alertManager.showError(localize("_GeneralErrorMessage"));
			}
		},
		[
			alertManager,
			announcementId,
			isFollowing,
			isMounted,
			onStatisticsChanged
		]
	);

	const { icon, key } = useMemo(
		(): { icon: FontIconName; key: LocalizationKey; } => {
			return isFollowing
				? { icon: "check", key: "_Following" }
				: { icon: "plus", key: "_Follow" };
		},
		[isFollowing]
	);

	return [icon, key, clickHandler];
}
